export const changeTableAdvisoryDataReducer = (state = [], action) => {
  switch (action.type) {
    case "CHANGE_TABLE_ADVISORY_DATA":
      return action.payload.tableAdvisoryData;
    default:
      return state;
  }
};
